<template>
	<div>
		<el-row class="content">
			<el-table v-loading="loading" :data="list" tooltip-effect="light" :cell-style="cellStyle" :header-cell-style="headCellStyle">
				<!--
				<el-table-column label="序号" prop="recid" width="50" />
				<el-table-column label="业务类型" align="center" :show-overflow-tooltip="true" prop="ywType" />
				<el-table-column label="区域" align="center" :show-overflow-tooltip="true" prop="region"/>
				&lt;!&ndash;newView:实体类中放一个表中不存在的字段,在查询数据的时候,推送时间小于一天则为true,否则为false&ndash;&gt;
				<el-table-column label="办事指南" align="left" prop="bszn" :show-overflow-tooltip="true" width="400">
					<template slot-scope="scope">
						<el-badge value="new" class="item" v-if="scope.row.newView=='true'">
							<span style="cursor: pointer" @click="openPage()">{{scope.row.bszn}}</span>
						</el-badge>
						<span v-if="scope.row.newView=='false'">{{scope.row.bszn}}</span>
					</template>
				</el-table-column>
				<el-table-column label="推送时间" align="center" prop="tsTime"/>
				-->
				<!--<el-table-column label="类型" align="left" prop="lawBusType" :formatter="lawBusTypesFormat"/>-->
				<!--<el-table-column label="区域" align="left" prop="lawArea" :formatter="lawAreasFormat"/>-->
				<!--newView:实体类中放一个表中不存在的字段,在查询数据的时候,推送时间小于一天则为true,否则为false-->
				<el-table-column label="法规政策名称" align="left" prop="lawName" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span style="cursor: pointer;color: #00afff"  @click="openPage(scope.row)">{{scope.row.lawName}}</span>
						<!--<el-tag size="mini" type="success">
                            {{lawRourceFormat(scope.row.lawRource)}}
                        </el-tag>-->
						<el-tag size="mini" type="success">
							new
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="业务类型" align="left" prop="lawRource" :show-overflow-tooltip="true" width="180">
					<template slot-scope="scope">
						{{lawRourceFormat(scope.row.lawRource)}}
					</template>
				</el-table-column>
				<!--                <el-table-column label="业务类型" align="center" :show-overflow-tooltip="true" prop="ywType"/>-->
				<el-table-column label="发布日期" align="center" prop="lawPubtime" width="180"/>
			</el-table>
			<pagination
					v-show="total>0"
					:total="total"
					:page.sync="queryParams.pageNum"
					:limit.sync="queryParams.pageSize"
					@pagination="getList"
			/>
		</el-row>
	</div>
</template>

<script>
	import {
		listLaw,
	} from "@/api/law/jbxx/law";
	import {
		listMullevel
	} from "@/api/law/mullevel/mullevel";
	export default {
		name: 'tsbszn',
		data() {
			return {
				// 遮罩层
				loading: false,
				// 总条数
				total: 0,
				list: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					lawBusTypes:'tszn'
				},
				lawBusTypes: [],
				lawAreas: [],
				lawywlxOptions:[],
			}
		},
		created() {
			/*this.getDicts("yw_flfg_lx").then(response => {
				this.lawBusTypes = response.data;
			});
			this.getDicts("yw_flfg_qy").then(response => {
				this.lawAreas = response.data;
			});*/
			this.listMullevel();
			this.getList();
		},
		methods: {
			// lawBusTypesFormat(row, column) {
			// 	return this.selectDictLabel(this.lawBusTypes, row.lawBusType);
			// },
			// lawAreasFormat(row, column) {
			// 	return this.selectDictLabel(this.lawAreas, row.lawArea);
			// },
			listMullevel(){
				const queryParams = {
					dictType: 'law_ywlx'
				};
				listMullevel(queryParams).then(response => {
					this.lawywlxOptions = response.data;
				});
			},
			lawRourceFormat(value) {
				return this.selectDictLabels(this.lawywlxOptions, value);
			},
			selectDictLabels(datas, value) {
				// debugger
				var actions = [];
				Object.keys(datas).map((key) => {
					if (datas[key].dictValue == ('' + value)) {
						actions.push(datas[key].dictName);
						return false;
					}
				})
				return actions.join('');
			},
			toPage(url) {
				this.$router.push({
					path: url,
				});
				this.$store.commit('SET_MAININDEX', url);
			},
			getList() {
				this.loading = true;
				listLaw(this.queryParams).then(response => {
					this.list = response.rows;
					this.total = response.total;
					this.loading = false;
				});
				/*
				this.loading = true;
				let that = this;
				setTimeout(function() {
					that.loading = false;
					if (that.queryParams.pageNum == 1) {
						that.list = [
							{recid: '1',ywType: '知识产权',region: '山东省',newView: 'true', bszn: '中国质量奖管理办法',tsTime: '2021-10-29'},
							{recid: '3',ywType: '泰山品质认证',region: '山东省',newView: 'true', bszn: '山东省市场监管局关于征求《山东省市场监督管理局关于继续实施好电梯维护保养单位告知性登记制度的通知》修改意见的通知',tsTime: '2021-10-12'},
							{recid: '4',ywType: '党建引领',region: '威海市',newView: 'false', bszn: '计量纠纷调解',tsTime: '2021-10-12'},
							{recid: '5',ywType: '惠企政策',region: '威海市',newView: 'false', bszn: '质量月活动',tsTime: '2021-10-12'},
							{recid: '6',ywType: '知识产权',region: '山东省',newView: 'false', bszn: '《山东省市场监管局产品质量监督抽查工作规范社会公开征求意见采纳情况',tsTime: '2021-10-12'},
							{recid: '7',ywType: '质量提升',region: '山东省',newView: 'false', bszn: '《山东省市场监督管理局关于特种设备作业人员资格考核的实施意见》征求意见采纳情况',tsTime: '2021-10-12'},
							{recid: '8',ywType: '泰山品质认证',region: '山东省',newView: 'false', bszn: '山东省市场监督管理局关于对拟批准发布的《山东省市场监督管理局安全防护计量器具计量监督管理工作指导意见》进行公示的通知',tsTime: '2021-10-12'},
							{recid: '9',ywType: '党建引领',region: '威海市',newView: 'false', bszn: '特种设备信息查询',tsTime: '2021-10-12'},
							{recid: '10',ywType: '惠企政策',region: '威海市',newView: 'false', bszn: '知识产权维权援助',tsTime: '2021-10-12'},
						];
					} else {
						that.list = [
							{recid: '1',ywType: '知识产权',region: '山东省',newView: 'true', bszn: '中国质量奖管理办法',tsTime: '2021-10-29'},
							{recid: '3',ywType: '泰山品质认证',region: '山东省',newView: 'true', bszn: '山东省市场监管局关于征求《山东省市场监督管理局关于继续实施好电梯维护保养单位告知性登记制度的通知》修改意见的通知',tsTime: '2021-10-12'},
							{recid: '4',ywType: '党建引领',region: '威海市',newView: 'false', bszn: '计量纠纷调解',tsTime: '2021-10-12'},
							{recid: '5',ywType: '惠企政策',region: '威海市',newView: 'false', bszn: '质量月活动',tsTime: '2021-10-12'},
							{recid: '6',ywType: '知识产权',region: '山东省',newView: 'false', bszn: '《山东省市场监管局产品质量监督抽查工作规范社会公开征求意见采纳情况',tsTime: '2021-10-12'},
							{recid: '7',ywType: '质量提升',region: '山东省',newView: 'false', bszn: '《山东省市场监督管理局关于特种设备作业人员资格考核的实施意见》征求意见采纳情况',tsTime: '2021-10-12'},
							{recid: '8',ywType: '泰山品质认证',region: '山东省',newView: 'false', bszn: '山东省市场监督管理局关于对拟批准发布的《山东省市场监督管理局安全防护计量器具计量监督管理工作指导意见》进行公示的通知',tsTime: '2021-10-12'},
							{recid: '9',ywType: '党建引领',region: '威海市',newView: 'false', bszn: '特种设备信息查询',tsTime: '2021-10-12'},
							{recid: '10',ywType: '惠企政策',region: '威海市',newView: 'false', bszn: '知识产权维权援助',tsTime: '2021-10-12'},
						];
					}
					that.total = 15;
				}, 500);
				*/
			},
			//单元格的style的回调方法
			cellStyle({row,column,rowIndex,columnIndex}){
				//columnIndex:是一行一行的从左往右显示
				// if(columnIndex === 3){
				// 	return 'padding-left: 30px;';//left是从左往右平移
				// }else {
				// 	return ''
				// }
			},
			//表头行的style的回调方法    rowIndex:行  columnIndex:列 都是从0开始的
			headCellStyle({row,column,rowIndex,columnIndex}){
				// if(columnIndex === 3){
				// 	return 'padding-left: 150px;';
				// }else {
				// 	return ''
				// }
			},
			openPage(item){
				this.utils.windowOpen('/main/zscqzhfw/flfgzc/detail/'+item.recid);
			},
		}
	}
</script>

<style scoped="scoped">
	.item {
		margin-top: 10px;
		padding-right: 0.625rem;
	}
</style>
